import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { GET_USER_INF, SET_CALL_WAITING } from "~/constants/apiEndpoints";
import type {
  GetUserInfoResponse,
  MyProfile,
  UpdateCallWaitingRequest,
  UpdateCallWaitingResponse,
} from "~/features/myProfile/types";
import { apiClient } from "~/lib/apiClient";
import { queryClient } from "~/lib/queryClient";
import { queryKeys } from "~/lib/queryKeys";

// オフライン通話は UI で操作しないため OFF 固定（set_call_waiting 送信時の既定値）
export const OFFLINE_CALL_DEFAULT = false;

// 自分のプロフィール取得。route loader・複数 feature・共有フックから参照されるため lib/queryOptions 配下に置く。
export const myProfileQueryOptions = queryOptions({
  queryKey: queryKeys.myProfile.detail(),
  queryFn: () => apiClient<GetUserInfoResponse>(GET_USER_INF),
});

// 通話許可（video/voice/offline）の更新。設定画面・通話リクエスト送信時・投稿時から共通利用する。
export const updateCallWaitingMutationOptions = mutationOptions({
  mutationFn: (data: UpdateCallWaitingRequest) =>
    apiClient<UpdateCallWaitingResponse>(
      SET_CALL_WAITING,
      data as Record<string, unknown>,
    ),
  onMutate: async (variables) => {
    await queryClient.cancelQueries({
      queryKey: queryKeys.myProfile.detail(),
    });
    const previous = queryClient.getQueryData<MyProfile>(
      queryKeys.myProfile.detail(),
    );
    if (previous) {
      queryClient.setQueryData<MyProfile>(queryKeys.myProfile.detail(), {
        ...previous,
        video_call_waiting: variables.video_call_waiting,
        voice_call_waiting: variables.voice_call_waiting,
      });
    }
    return { previous };
  },
  onError: (_err, _variables, context) => {
    if (context?.previous) {
      queryClient.setQueryData(queryKeys.myProfile.detail(), context.previous);
    }
  },
  onSettled: () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.myProfile.detail(),
    });
  },
});
